const arrow_left = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.41421%2012L16.7071%2019.2929L15.2929%2020.7071L6.58578%2012L15.2929%203.29291L16.7071%204.70712L9.41421%2012Z'/%3e%3c/svg%3e";
export {
  arrow_left as default
};
//# sourceMappingURL=arrow_left.svg.es.js.map
